/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ArtIcon = /*#__PURE__*/ createSvgIcon(
  'ArtIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M5.146 17.104a3.767 3.767 0 01-1.76-.427A4.134 4.134 0 012 15.521a1.71 1.71 0 001.104-.48c.306-.29.458-.652.458-1.083 0-.666.23-1.225.691-1.677a2.306 2.306 0 011.677-.677c.658 0 1.212.23 1.664.687.451.458.677 1.014.677 1.667 0 .875-.302 1.618-.906 2.23-.605.61-1.344.916-2.22.916zm0-1.396c.481 0 .893-.171 1.236-.514.343-.342.514-.754.514-1.236a.923.923 0 00-.281-.677.923.923 0 00-.678-.28.923.923 0 00-.677.28.923.923 0 00-.28.677c0 .306-.036.601-.105.886-.07.285-.201.538-.396.76.111.028.222.052.333.073.112.021.223.031.334.031zm4.917-3.541l-2.126-2.125 6.646-6.646a.965.965 0 01.709-.292c.277 0 .514.097.708.292l.708.708c.195.2.292.435.292.703a.947.947 0 01-.292.693l-6.645 6.667z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ArtIcon;
